/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    usuarioslist: true,
    usuariosadd: false,
    usuarios: [],
}